import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../../../contexts/AuthContext';
import { useHousehold } from '../../../contexts/HouseholdContext';
import { useNotifications } from '../../../hooks/useNotifications';
import { mainLayoutStyles } from './MainLayout.styles';
import HouseholdSelector from '../../../features/HouseholdSelector';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { logout } = useAuth();
  const { activeHouseholdId, showHouseholdSelector } = useHousehold();
  const navigate = useNavigate();
  const { showSuccess } = useNotifications();

  const shouldShowSelector = !activeHouseholdId || showHouseholdSelector;

  const menuItems = [
    { text: 'Listy zakupów', path: '/shopping-lists' },
    { text: 'Produkty', path: '/products' },
    { text: 'Gospodarstwa domowe', path: '/households' },
    { text: 'Moje konto', path: '/account' },
  ];

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const handleLogout = () => {
    logout();
    showSuccess('Wylogowano pomyślnie', 'Do zobaczenia!');
    setDrawerOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <Box sx={mainLayoutStyles.root}>
      <AppBar position="fixed" sx={mainLayoutStyles.appBar}>
        <Toolbar>
          <Typography
            variant="h6"
            align="center"
            sx={mainLayoutStyles.title}
            onClick={handleLogoClick}
          >
            Listum
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={toggleDrawer}
            sx={mainLayoutStyles.menuButton}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer}
        sx={mainLayoutStyles.drawer}
      >
        <Box sx={mainLayoutStyles.drawerContent}>
          <List sx={mainLayoutStyles.menuList}>
            {menuItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton onClick={() => handleNavigate(item.path)}>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          <Box sx={mainLayoutStyles.logoutSection}>
            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={handleLogout}
            >
              Wyloguj się
            </Button>
          </Box>
        </Box>
      </Drawer>

      <Box component="main" sx={mainLayoutStyles.content}>
        <Toolbar />
        {!shouldShowSelector && children}
      </Box>

      <HouseholdSelector show={shouldShowSelector} />
    </Box>
  );
};

export default MainLayout;